import { gql } from 'apollo-angular';

const SELECT_OFFERS = gql`
  mutation updatePurchasePlanOffers($purchasePlanId: Long!,$offers: [OfferIdInput]!) {
    updatePurchasePlanOffers(
      input: { 
        purchasePlanId: $purchasePlanId, 
        offers: $offers
      }) 
    {
      updated
    }
  }
`;

export default SELECT_OFFERS;
